import mixins from '@synergycms_core/less/mixins';

export default {
    hideSection:{},
    textDate:{},
    textWarning:{},
    roomsDetail: {
        ...mixins.displayFlex('row', 'left', 'center', '0.5em'),
        flexWrap: 'wrap',
        padding: '0.5em',
    },
    quotaListItem: {
        marginLeft: '20px',
        ...mixins.displayFlex('row', 'left', 'center', '0.5em'),
        marginBottom: '10px',
        marginTop: '20px',
        '& $textDate':{
            textAlign: 'left',
        },
        '& $textWarning':{
            width: 'auto',
            textAlign: 'left',
            color: '#d0021b',
            fontSize: '12px',
        },
        flexWrap: 'wrap'
    },
    quotaSelect: {
        padding: '0.5em',
    },
    servicePrice:{},
    serviceBookButton:{},
    boxPrice: {},
    servicePriceSelected: {},
    secondRowFooter:{
        width: '100%',
        padding: '10px 0 13px',
        display: 'table',
        boxSizing: 'border-box',
        '&$hideSection':{
            display: 'none',
        },
        '@media (min-width:801px)': {
            width: 'unset',
            padding: '15px 20px'
        },
        '& $servicePrice': {
            paddingRight: '0',
            paddingLeft: '10px',
            textAlign: 'left',
            display: 'table-cell',
            padding: '0 10px',
            verticalAlign: 'middle',
            '& > span': {
                display: 'block'
            },
            '@media (min-width:801px)': {
                width: '100%',
                paddingRight: '10px',
                paddingLeft: '0px',
                textAlign: 'right',
            },
            '&:lang(ar)': {
                paddingLeft: '10px',
                paddingRight: 0,
                textAlign: 'left',
            },
            '& $boxPrice': {
                '@media (min-width:801px)': {
                    textAlign: 'right',
                },
            },
            '& $servicePriceSelected': {
                width: 'max-content',
            }
        },
        
        '& $serviceBookButton': {
            display: 'table-cell',
            verticalAlign: 'middle',
            paddingRight: '10px',
            '& > button': {
                minWidth: '140px',
                height: '40px',
                font:"16px 'Roboto', sans-serif",
                '@media (min-width:801px)': {
                    '& > button': {
                        width: '140px'
                    }
                },
                '&$deleteServiceBtn':{
                    border: '1px solid #000',
                    color: '#000',
                    '&:hover':{
                        color: '#000',
                    }
                }
            },
            '@media (min-width:801px)': {
                paddingRight: '0'
            },
            '&:lang(ar)': {
                paddingLeft: '10px',
                paddingRight: 0
            }
        },
    },
    thirdRow: {
        color: data => data.mainColor,
        font:"300 13px 'Roboto', sans-serif",
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: '20px',
        position: 'relative',
        bottom: '15px',
        '@media (max-width:800px)': {
            padding: '15px 10px 0 0',
        },
        '& $textWarning': {
            color: data => data.mainColor,
            font:"300 11px 'Roboto', sans-serif",
            '@media (min-width:801px)': {
                paddingTop: '15px',
                font:"300 13px 'Roboto', sans-serif",
            }
        }
    },
    quotaSelectContainer:{
        width: '60px',
        marginRight: '5px'
    },
    deleteServiceBtn:{
        cursor: 'pointer',
        fontSize: '13px',
        '@media (min-width:801px)': {
            fontSize: '15px',
        },
    },
    showingRooms:{},
    containerRoomsPrice:{
        '&$showingRooms':{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            '@media (max-width:800px)': {
                flexDirection: 'column',
            },
        },
    },
    quotaServices:{},
    quotaServicesDatePicker:{
        '&$quotaServices':{
            zIndex: 'unset',
            overflow: 'visible !important',
            '@media (min-width:801px)': {
                height: '410px',
                '& > div':{
                    height: '100%',
                    '& > div':{
                        height: '100%',
                        padding: '0',
                        '& > div:nth-child(1)':{
                            display: 'none',
                        },
                        '& > div:nth-child(3)':{
                            display: 'none',
                        }
                    }
                }
            },
        }

    },
    closeSectionBtn:{
        marginBottom: '10px',
        marginRight: '10px',
        '@media (min-width:801px)': {
            marginBottom: '15px',
            right: '20px',
            position: 'relative',
            marginRight: '0',
        },
    }

};
